import React, { Component } from 'react';
import { DraggableWindow } from '../DraggableWindow';
import { LayoutContext } from '../../../../modules/ContextModules/LayoutContext';
import './Socioeconomic.css';

import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    ArcElement,
    PointElement,
    BarElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
} from 'chart.js';

import { Line, Bar, Pie } from 'react-chartjs-2';

ChartJS.register(
    CategoryScale,
    LinearScale,
    ArcElement,
    PointElement,
    LineElement,
    BarElement,
    Title,
    Tooltip,
    Legend
);

const townNames = ["南投市", "埔里鎮", "草屯鎮", "竹山鎮", "集集鎮", "名間鄉", "鹿谷鄉", "中寮鄉", "魚池鄉", "國姓鄉", "水里鄉", "信義鄉", "仁愛鄉"]

export class Socioeconomic extends Component {
    static contextType = LayoutContext;
    constructor(props) {
        super(props);
        this.state = {
            activeChartType: 'bar',
        }
    }

    componentDidMount() {
    }

    selectTown_OnChange(e) {
        const { socioeconomicContext } = this.context;
        let townName = e.target.value;
        let newList = socioeconomicContext.selectTown;

        let index = newList.indexOf(townName);
        if (index == -1) {
            newList.push(townName);
        }
        else {
            newList.splice(index, 1);
        }

        if (socioeconomicContext.layerModule) {
            socioeconomicContext.layerModule.repaint(newList);
            if (socioeconomicContext.showChart) {
                this.updateData();
            }
        }

        socioeconomicContext.update({ selectTown: newList });
    }

    render() {
        // 在 render 中將可以使用 this.context
        return (
            <DraggableWindow
                header="社會經濟資料"
                content={this.content()}
                width={this.props.width}
                height={this.props.height}
                defaultPosition={this.props.defaultPosition}
                handleMinimize={this.props.handleMinimize}
                handleCancel={this.props.handleCancel}
                isShow={this.props.isShow}  />
        );
    }

    chartContent() {
        const { socioeconomicContext } = this.context;
        if (this.state.activeChartType === 'line') {
            return (
                <Line options={{
                    responsive: true,
                    maintainAspectRatio: false,
                    plugins: {
                        legend: {
                            labels: {
                                boxWidth: 13,
                                boxHeight: 12
                            }
                        },
                        title: {
                            display: false
                        }
                    },
                    radius: 0,
                    scales: {
                        x: {
                            grid: {
                                display: false
                            },
                            ticks: {
                                autoSkip: false,
                                maxRotation: 0
                            }
                        }
                    }
                }}
                    data={{
                        labels: socioeconomicContext.labels,
                        datasets: [{
                            label: '數量',
                            data: socioeconomicContext.data,
                            fill: false,
                            borderColor: 'rgb(75, 192, 192)',
                            tension: 0.1
                        }]
                    }} />
            );
        }
        if (this.state.activeChartType === 'bar') {
            return (
                <Bar options={{
                    responsive: true,
                    maintainAspectRatio: false,
                    plugins: {
                        legend: {
                            labels: {
                                boxWidth: 13,
                                boxHeight: 12
                            }
                        },
                        title: {
                            display: false
                        }
                    },
                    radius: 0,
                    scales: {
                        x: {
                            grid: {
                                display: false
                            },
                            ticks: {
                                autoSkip: false,
                                maxRotation: 0
                            }
                        }
                    }
                }}
                    data={{
                        labels: socioeconomicContext.labels,
                        datasets: [{
                            label: '',
                            data: socioeconomicContext.data,
                            backgroundColor: socioeconomicContext.backgroundColorArray,
                            borderColor: socioeconomicContext.borderColorArray,
                            borderWidth: 1
                        }]
                    }} />
            );
        }
        if (this.state.activeChartType === 'pie') {
            return (
                <Pie options={{
                    responsive: true,
                    maintainAspectRatio: false,
                    plugins: {
                        legend: {
                            labels: {
                                boxWidth: 13,
                                boxHeight: 12
                            }
                        },
                        title: {
                            display: false
                        }
                    },
                    radius: 100
                }}
                    data={{
                        labels: socioeconomicContext.labels,
                        datasets: [
                            {
                                label: '# of Votes',
                                data: socioeconomicContext.data,
                                backgroundColor: socioeconomicContext.backgroundColorArray,
                                borderColor: socioeconomicContext.borderColorArray,
                                borderWidth: 1,
                            },
                        ],
                    }}
                />
            );
        }
    }

    showChart_OnClick() {
        const { socioeconomicContext } = this.context;

        if (socioeconomicContext.layerModule) {
            this.updateData();
            socioeconomicContext.update({ showChart: true, height: 500 })
        }
    }

    updateData() {
        const { socioeconomicContext } = this.context;
        let labels = [];
        let data = [];
        let rgbArray = [];
        let rgbaArray = [];

        if (socioeconomicContext.layerModule) {
            let colorList = socioeconomicContext.layerModule.colorList;
            socioeconomicContext.layerModule.entityList.forEach((entity, index) => {

                if (socioeconomicContext.selectTown.indexOf(entity.townName) >= 0) {
                    labels.push(entity.townName);
                    data.push(entity.count);
                    let rgb = `rgb(${colorList[index].r} , ${colorList[index].g} , ${colorList[index].b} )`;
                    let rgba = `rgb(${colorList[index].r} , ${colorList[index].g} , ${colorList[index].b} ,0.2 )`;
                    rgbArray.push(rgb);
                    rgbaArray.push(rgba)
                }
            });

            socioeconomicContext.update({ data: data, labels: labels, backgroundColorArray: rgbaArray, borderColorArray: rgbArray })
        }
    }

    content() {
        const { socioeconomicContext } = this.context;

        return (
            <div className='socioeconomic'>
                <div className='socioeconomic-row'>
                    <div>{
                        townNames.map(townName => {
                            return (
                                <span key={townName}>
                                    <input type="checkbox" id={townName + "ckb"} name={townName + "ckb"} value={townName}
                                        onChange={(e) => { this.selectTown_OnChange(e); }} checked={socioeconomicContext.selectTown.indexOf(townName) >= 0 ? true : false} />
                                    <label htmlFor={townName + "ckb"}>{townName}</label>
                                </span>
                            );
                        })
                    }
                    </div>
                </div>
                <div className='socioeconomic-row'>
                </div>
                {socioeconomicContext.showChart ? <div className='socioeconomic-row' style={{ maxHeight: "none" }}>
                    <div className="socioeconomic-statistics-chart">
                        {this.chartContent()}
                    </div>
                </div> : null}
                <div className='socioeconomic-row'>
                    <select onChange={(e) => { this.setState({ activeChartType: e.target.value }) }}>
                        <option value={'bar'} >長條圖</option>
                        <option value={'line'} >折線圖</option>
                        <option value={'pie'} >圓餅圖</option>
                    </select>
                    <button className='socioeconomic-btn' onClick={() => { this.showChart_OnClick(); }}>顯示</button>
                </div>
            </div>
        );
    }
}